import { useMutation } from '@tanstack/react-query';

import { GUID, InternalUserProfile } from '@ndvr/auth-api';
import { NoteView } from '@ndvr/customer-api';

import { CustomerApi } from '../../API';
import { Toast } from '../../widgets';
import { useAuthContext } from '../auth/Auth';

// Sharing links the note's event to each recipient's calendar, which is what grants them
// access to the note. That only touches the recipients' calendars, so nothing in the current
// user's views goes stale and there is no cache to invalidate. The mutation takes only the
// recipients so any share dialog can drive it; the note is bound here, in the hook.
export const useShareMeetingNote = (note: NoteView) => {
    const { selectedTenants } = useAuthContext();
    return useMutation({
        mutationFn: async (recipientInternalUserGUIDs: GUID<InternalUserProfile>[]) => {
            await CustomerApi({ hideError: true }).shareLocalEventNote(
                note.noteGUID,
                { recipientInternalUserGUIDs },
                { tenantGUIDs: selectedTenants.map(({ tenantGUID }) => tenantGUID) },
            );
        },
        onSuccess: (_, recipientInternalUserGUIDs) =>
            Toast.success(
                `Note shared with ${recipientInternalUserGUIDs.length} ${recipientInternalUserGUIDs.length === 1 ? 'teammate' : 'teammates'}`,
            ),
        onError: (error: Error) => Toast.forError(error, 'Failed to share note'),
    });
};
